import api from './api';

export interface Position {
    id: number;
    name: string;
}

class PositionService {
    async getPositions(): Promise<Position[]> {
        const response = await api.get('/api/positions');
        return response.data;
    }
}

export const positionService = new PositionService(); 